import { PdfItem } from '../../pages/pdf/types';

interface Props {
  data: PdfItem['data'];
}

export const PdfSubHeading = ({ data }: Props) => {
  const { content } = data;

  return <h3 className="scroll-mt-16 px-2">{content}</h3>;
};
